/**
 * Copy SEO del home — tono profesional (modelo / creadora de contenido),
 * sin mencionar Telegram, Instagram premium ni "exclusive community" en metadata.
 *
 * Sincronizar descripción por defecto con:
 * - api/site-settings.ts (DEFAULT_SETTINGS.description)
 * - src/lib/siteSettingsDefaults.ts
 * - cloudflare-worker-delfuocampo/worker.js (DEFAULT_SITE_SETTINGS.description)
 * - scripts/generate-index-html.ts (BRAND_DESCRIPTION fallback)
 */

import {
  BRAND_AGE,
  BRAND_COUNTRY,
  BRAND_DESCRIPTION,
  BRAND_PERSON_NAME,
} from "@/lib/brandConfig";

export const BRAND_SEO_HOME_TITLE_ES = BRAND_PERSON_NAME
  ? `${BRAND_PERSON_NAME} | Modelo y creadora de contenido`
  : "Modelo y creadora de contenido";

/** ~155 caracteres — apto para Google snippet. */
export const BRAND_SEO_HOME_DESCRIPTION_ES =
  BRAND_DESCRIPTION?.trim() ||
  "Modelo y creadora de contenido argentina. Moda, estilo de vida y proyectos en redes. Perfil oficial para campañas y colaboraciones con marcas.";

export const BRAND_SEO_HOME_KEYWORDS_ES = [
  BRAND_PERSON_NAME,
  "modelo",
  "creadora de contenido",
  "influencer",
  "moda",
  "lifestyle",
  "Buenos Aires",
  BRAND_COUNTRY,
  "campañas",
  "colaboraciones",
  "redes sociales",
]
  .filter(Boolean)
  .join(", ");

export const BRAND_SEO_HOME_OG_DESCRIPTION_ES =
  BRAND_PERSON_NAME && BRAND_AGE
    ? `${BRAND_PERSON_NAME} — modelo y creadora de contenido para redes, ${BRAND_AGE} años, desde Buenos Aires. Campañas, colaboraciones y novedades.`
    : BRAND_SEO_HOME_DESCRIPTION_ES;

/** Inglés discreto para hreflang / crawlers internacionales (sin Telegram ni "premium access"). */
export const BRAND_SEO_HOME_TITLE_EN = BRAND_PERSON_NAME
  ? `${BRAND_PERSON_NAME} | Model & Content Creator`
  : "Model & Content Creator";

export const BRAND_SEO_HOME_DESCRIPTION_EN = BRAND_PERSON_NAME
  ? `Official site of ${BRAND_PERSON_NAME}. Argentine model and social content creator — fashion, lifestyle and brand collaborations.`
  : "Argentine model and social content creator — fashion, lifestyle and brand collaborations.";

export type HomepageSeoLocale = "es" | "en";

export function getHomepageSeoCopy(locale: HomepageSeoLocale = "es") {
  if (locale === "en") {
    return {
      title: BRAND_SEO_HOME_TITLE_EN,
      description: BRAND_SEO_HOME_DESCRIPTION_EN,
      keywords: [
        BRAND_PERSON_NAME,
        "model",
        "content creator",
        "influencer",
        "fashion",
        "lifestyle",
        "Buenos Aires",
        "Argentina",
        "brand collaborations",
      ]
        .filter(Boolean)
        .join(", "),
      ogTitle: BRAND_SEO_HOME_TITLE_EN,
      ogDescription: BRAND_SEO_HOME_DESCRIPTION_EN,
      htmlLocale: "en_US" as const,
    };
  }

  return {
    title: BRAND_SEO_HOME_TITLE_ES,
    description: BRAND_SEO_HOME_DESCRIPTION_ES,
    keywords: BRAND_SEO_HOME_KEYWORDS_ES,
    ogTitle: BRAND_SEO_HOME_TITLE_ES,
    ogDescription: BRAND_SEO_HOME_OG_DESCRIPTION_ES,
    htmlLocale: "es_AR" as const,
  };
}